import { render, staticRenderFns } from "./Ward.vue?vue&type=template&id=e2b1f686&"
import script from "./Ward.vue?vue&type=script&lang=ts&"
export * from "./Ward.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2b1f686')) {
      api.createRecord('e2b1f686', component.options)
    } else {
      api.reload('e2b1f686', component.options)
    }
    module.hot.accept("./Ward.vue?vue&type=template&id=e2b1f686&", function () {
      api.rerender('e2b1f686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/Ward.vue"
export default component.exports